"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialSelect = void 0;
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const react_select_1 = require("react-select");
require("./select.less");
let MaterialSelect = class MaterialSelect extends react_1.Component {
    constructor() {
        super(...arguments);
        this.value = "";
        // E-059
        this.handleOnChange = (value) => {
            this.value = value !== null ? value.value : "";
            this.props.onSelect && this.props.onSelect(this.value);
        };
        this.handleInputChange = (value) => {
            this.value = value;
            this.props.onInputChange && this.props.onInputChange(this.value);
        };
        // E-059.810
        this.onInputKeyDown = (value) => {
            this.value = value;
            this.props.onInputKeyDown && this.props.onInputKeyDown(this.value);
        };
    }
    render() {
        const { className = "", disabled, label = "", options, placeholder, required, searchable = false, value, missing, width, backgroundColor = false, // C-123
        showDisabledSites, } = this.props;
        const isMissing = missing ? "select--missing" : "";
        return (React.createElement("div", { className: `select ${className} ${isMissing}`, style: { width: `${width || null}` } },
            React.createElement("div", { className: "select__label" }, label),
            React.createElement(react_select_1.default, { openOnFocus: true, value: this.value || value, searchable: searchable, onInputChange: this.handleInputChange, onChange: this.handleOnChange, disabled: disabled, options: options, optionRenderer: (option) => (React.createElement(React.Fragment, null,
                    React.createElement("div", { style: {
                            backgroundColor: backgroundColor == true ? showDisabledSites == true ? !option.live ? '#a5a5a5e8' : '' : '' : '',
                            width: backgroundColor == true ? showDisabledSites == true ? !option.live ? '100%' : '' : '' : '',
                            height: backgroundColor == true ? showDisabledSites == true ? !option.live ? '40px' : '' : '' : '',
                            display: backgroundColor == true ? showDisabledSites == true ? !option.live ? 'flex' : '' : '' : '',
                            alignItems: backgroundColor == true ? showDisabledSites == true ? !option.live ? 'center' : '' : '' : '',
                            padding: backgroundColor == true ? showDisabledSites == true ? !option.live ? '0 5px' : '' : '' : '',
                        } }, option.label))), required: required, placeholder: placeholder, onSelectResetsInput: false, onInputKeyDown: this.onInputKeyDown })));
    }
};
__decorate([
    mobx_1.observable
], MaterialSelect.prototype, "value", void 0);
MaterialSelect = __decorate([
    mobx_react_1.observer
], MaterialSelect);
exports.MaterialSelect = MaterialSelect;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/select/select.tsx
// module id = 3158
// module chunks = 0